export const kCaseCardIdBase = "case-card"
